import dayjs from 'dayjs';

export function formatStringIntoDate(
  date: string,
  format = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
) {
  return dayjs(date, 'DD/MM/YYYY').format(format);
}
